// extracted by mini-css-extract-plugin
export default {"container":"DurationAndTopic__container___FgAYi","termsDropdown":"DurationAndTopic__termsDropdown___nElO6"};